import React from 'react';
import Button from '@atlaskit/button';
import AppSwitcherIcon from '@atlaskit/icon/glyph/app-switcher';
import Popup from '@atlaskit/popup';
import { NavigationItem } from '@css-xp/graphtypes';
import { atlassianLogoUrl } from '../../icon-data-urls';
import { getPartnerPortalUrl, getResourceHubUrl } from '../utils/navigation-utils';
import NavigationMenu from './navigation-menu';
import { SWITCHER, NAVIGATION_TYPE } from '../navigation-enums';
import { getPartnerServiceDeskUrlForGenericHelp } from '../utils/partner-service-desk-utils';

export const AppSwitcher = ({ appLinks = [] }: { appLinks?: NavigationItem[] }) => {
  const [isAppSwitcherOpen, setIsAppSwitcherOpen] = React.useState(false);

  const links: NavigationItem[] = appLinks;

  const redirectionData = [
    {
      name: SWITCHER.PARTNER_PORTAL,
      url: getPartnerPortalUrl(),
      iconUrl: atlassianLogoUrl,
      typename: NAVIGATION_TYPE.NAVIGATION_LINK,
    },
    {
      name: SWITCHER.PARTNER_SUPPORT,
      url: getPartnerServiceDeskUrlForGenericHelp(),
      iconUrl: atlassianLogoUrl,
      typename: NAVIGATION_TYPE.NAVIGATION_LINK,
    },
    {
      name: SWITCHER.RESOURCE_HUB,
      url: getResourceHubUrl(),
      iconUrl: atlassianLogoUrl,
      typename: NAVIGATION_TYPE.NAVIGATION_LINK,
    },
  ];

  if (appLinks.length === 0) {
    const redirectionDataNames = [SWITCHER.PARTNER_PORTAL, SWITCHER.PARTNER_SUPPORT, SWITCHER.RESOURCE_HUB];
    for (const x in redirectionData) {
      if (redirectionDataNames.includes(redirectionData[x].name)) {
        links.push(redirectionData[x]);
      }
    }
  }
  const showAppSwitcher = [
    {
      typename: NAVIGATION_TYPE.NAVIGATION_GROUP,
      name: 'Switch To',
      links: links,
    },
  ];

  return (
    <Popup
      content={() => <NavigationMenu navItems={showAppSwitcher} />}
      isOpen={isAppSwitcherOpen}
      onClose={() => setIsAppSwitcherOpen(false)}
      placement="bottom-end"
      trigger={(triggerProps) => (
        <>
          <Button
            isSelected={isAppSwitcherOpen}
            label="Switch to..."
            appearance="subtle-link"
            iconBefore={<AppSwitcherIcon label="app switcher icon" />}
            onClick={() => setIsAppSwitcherOpen(true)}
            {...triggerProps}
          />
        </>
      )}
    />
  );
};

export default AppSwitcher;
